// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyContacts__list-c7de21 {
  flex: 1;
}

.MyContacts__placeholders-a580b0 {
  padding: 8px 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectContacts/Users/MyContacts/MyContacts.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".list {\n  flex: 1;\n}\n\n.placeholders {\n  padding: 8px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `MyContacts__list-c7de21`,
	"placeholders": `MyContacts__placeholders-a580b0`
};
module.exports = ___CSS_LOADER_EXPORT___;
